export default __webpack_public_path__ + "static/media/dubare_elephant_camp.2d0ef700.jpg";